import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Modal, Button, Paper, PaperHeadline, PaperContent, Text } from '../../'
import { WarningIconRed, WarningIconGreen } from '../SvgIcons'

export class ClickToCancelModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    modalText: PropTypes.string,
    onClose: PropTypes.func,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
    isCancelled: PropTypes.bool,
    id: PropTypes.string,
    updateAutoRenewal: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    }),
    closeButtonProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    })
  }

  render() {
    const {
      open,
      onClose,
      className,
      id,
      isCancelled,
      modalText,
      title,
      headline,
      errorMessage,
      updateAutoRenewal,
      closeButtonProps,

    } = this.props

    return (
      <Modal
        open={open}
        onClose={onClose}
        className={className}
        id={id}
        refProp
      >
        <div className='ui-click-to-cancel-modal'>
          <Paper>
            <div className='ui-report-found-pet-icon'>
              {isCancelled ? <WarningIconRed /> : <WarningIconGreen />}
            </div>
            <div>
              <PaperHeadline>
                Turn {isCancelled ? 'off ' : 'on '} auto-renewal
              </PaperHeadline>
              <PaperContent className='ui-click-to-cancel-modal-content'>
                {/* {errorMessage && (
                  <Text
                    className='ui-click-to-cancel-modal__error-message'
                    type={Text.Types.bodyBold}
                  >
                    {errorMessage}
                  </Text>
                )} */}
                <Text type={Text.Types.title} className="ui-click-to-cancel-card__text" >
                  {
                    isCancelled
                      ? modalText
                      : "By turning on auto-renewal, your subscription will renew automatically at the end of each period, ensuring uninterrupted access to all your benefits. Would you like to proceed?"
                  }
                </Text>
                <div className='ui-click-to-cancel-modal__actions'>
                  <Button
                    color={Button.Colors.tertiary}
                    variant={Button.Variants.filled}
                    {...updateAutoRenewal}
                  >
                    Turn {isCancelled ? 'off ' : 'on '} Auto-Renewal
                  </Button>
                  <Button
                    color={Button.Colors.secondary}
                    variant={Button.Variants.outlined}
                    {...closeButtonProps}
                  >
                    Keep Auto-Renewal {!isCancelled ? 'off' : 'on'} 
                  </Button>
                </div>
              </PaperContent>
            </div>
          </Paper>
        </div>
      </Modal>
    )
  }
}
